// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__27jm0","inline":"card_inline__1P9vH","content":"card_content__2MoXc","icon":"card_icon__1BNMc","titel":"card_titel__1w37W"};